import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { FeatureDemandBannerStyled } from '../FeatureDemandBannerStyled';
import { rem } from 'polished';

export const FeatureDemandBannerAP = styled(FeatureDemandBannerStyled)`
   
`;
